import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function GiftImage(props) {
	return {
		componentName: 'GiftImage',
		componentId: uuidv4(),
		props: _.merge(
			{
				minWidth: 125,
				maxWidth: 125,
				minHeight: 125,
				maxHeight: 125,
				mzGiftImage: 'https://i.imgur.com/EFLGTEP.png',
			},
			props,
		),
		childrenComponents: [],
	};
}
